export const talentServices = [
  {
    name: "Contract Staffing",
    icon: "Clock",
    description:
      "Technical professionals for project-based requirements, deployed quickly to keep initiatives on schedule.",
  },
  {
    name: "Contract-to-Hire",
    icon: "Repeat",
    description:
      "Flexible evaluation before permanent hiring, reducing risk while you find the right long-term fit.",
  },
  {
    name: "Direct Hire",
    icon: "UserPlus",
    description:
      "Permanent recruitment for critical positions, backed by specialized technical recruiting.",
  },
  {
    name: "Engineering Staffing",
    icon: "Cpu",
    description:
      "Specialized engineering and technical professionals across software, hardware and semiconductor domains.",
  },
  {
    name: "Dedicated Teams",
    icon: "Users",
    description:
      "Build focused teams around your business requirements, managed for accountability and delivery.",
  },
  {
    name: "Offshore Development Teams",
    icon: "Globe2",
    description:
      "Scalable engineering capacity for long-term initiatives, integrated with your processes and tools.",
  },
];

export const staffingProcess = [
  {
    step: "01",
    title: "Understand",
    description: "We start by deeply understanding the client's requirements, context and success criteria.",
  },
  {
    step: "02",
    title: "Source",
    description: "We identify qualified candidates through specialized networks and technical recruiting.",
  },
  {
    step: "03",
    title: "Screen",
    description: "Every candidate goes through rigorous technical and professional screening.",
  },
  {
    step: "04",
    title: "Present",
    description: "We present only qualified, well-matched candidates ready to contribute.",
  },
  {
    step: "05",
    title: "Support",
    description: "We provide ongoing engagement support throughout the relationship.",
  },
];
